import { Component, OnInit, effect, inject, input, signal } from '@angular/core';
import { InvoiceHandlingMode, SectionId, ThemeTypes } from '../theme.types';
import { InvoicePositionModel } from '../../../core/models/finance/financial-record.model';
import { BaseInvoiceThemeModel } from '../../../core/models/invoice/base-invoice-theme.model';
import { ContentArea } from '../../../core/models/invoice/invoice-document-detail.model';
import { DefaultInvoiceTemplate } from '../../../pages/finances/invoices/invoice.config';
import { ThemeRegistry } from '../theme.registry';
import { InvoiceStateService } from '../../../pages/finances/invoices/invoice-creation-editing/state-and-data-handling/invoice-state.service';
import { ActivatedRoute } from '@angular/router';
import { templateIdQueryParam } from '../../../core/resolver/invoice/invoice-data.resolver';

@Component({
  selector: 'app-invoice-theme-shell',
  templateUrl: './invoice-theme-shell.component.html',
  standalone: false,
})
export class InvoiceThemeShellComponent implements OnInit {
  // Inputs
  themeProps = input<BaseInvoiceThemeModel>(); // Needed if mode === 'print'
  contentAreas = input<Map<string, ContentArea>>(); // Needed if mode === 'print'
  invoicePositions = input<InvoicePositionModel[]>(); // Needed if mode === 'print'
  mode = input<InvoiceHandlingMode>(null);

  // Signals
  cmp = signal<null | any>(null);

  // DI
  private readonly invoiceStateService = inject(InvoiceStateService);
  private readonly activatedRoute = inject(ActivatedRoute);

  private isTemplate = false;
  private readonly themeType = signal<ThemeTypes>(DefaultInvoiceTemplate);

  constructor() {
    effect(() => {
      void this.loadCurrent(this.themeType());
    });
  }

  ngOnInit(): void {
    this.isTemplate = !!this.activatedRoute.snapshot.queryParams[templateIdQueryParam];
  }

  private async loadCurrent(tpl: ThemeTypes) {
    const themeDefinition = ThemeRegistry[tpl];
    const component = await themeDefinition.componentLoader();
    this.cmp.set(component);

    // If we are in creation mode and we don't use a template, load default values from local database.
    // Otherwise, the content areas and theme props have already been loaded by the invoice-data resolver.
    if (this.mode() === 'create' && !this.isTemplate) {
      const map = new Map<SectionId, ContentArea>(
        themeDefinition.sections.map((s) => [s.id, s.defaultContent]),
      );
      this.invoiceStateService.replaceAllContentAreaData(map);
      this.invoiceStateService.replaceThemeData(themeDefinition.defaultTheme);
    }
  }
}
